var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary","flat":""}},[_c('v-toolbar-title',[_vm._v("Modifica pratica")])],1),_c('moduleStructure',{attrs:{"id":_vm.$route.params.id,"edit-mode":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }